<div class="main-container">
  <div class="header-sticky">
    <div class="header-content">
      <div class="header-left">
        <img src="assets/GEA_Logo.png" alt="logo GEA" class="logo" routerLink="/" />
        <span class="header-title">| PID Diagram Genius</span>
      </div>
      <div class="header-center">
        <span class="center-title">
          {{ ControlSystemsName }}
        </span>
      </div>
      <div #profileButton class="profile-section" (click)="toggleDropdown()">
        <span class="profile-name">
          {{ userLogin ? userLogin : 'n/a' }}
        </span>
        <div class="menu-icon">
          <svg *ngIf="!currentShowDropdown" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M1.3335 4.66669L8.00016 11.3334L14.6668 4.66669" stroke="#ffff" stroke-width="1.4"
              stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
          <svg *ngIf="currentShowDropdown" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M14.6665 11.3333L7.99984 4.66665L1.33317 11.3333" stroke="#ffff" stroke-width="1.4"
              stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
        </div>
        <div #profileMenu class="dropdown-menu-header" *ngIf="currentShowDropdown"
          [ngStyle]="{ top: menuTop + 'px', right: menuRight + 'px' }" (click)="$event.stopPropagation()">
          <div class="dropdown-item" (click)="logout(); $event.stopPropagation()">
            <geaui-icon-v3 file="logout" class="icon-logout" [color]="'black'" [fileSize]="16"></geaui-icon-v3>
            <span>{{ 'UI-LIB.HEADER.LOGOUT' | translate }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>